import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';
import apiService from 'app/bff/services/apiService';
import { SystemParamTypesEnum, SystemParamIdEnum } from 'app/bff/enums/system';
import { ModalNamesEnum } from 'app/core/enums/ui/modals';
import { RootState } from 'app/store/types';
import { setIdleTimeoutStatusAction, setModalVisibleAction } from 'app/store/ui/actions';

const IdleTimer: React.FC = () => {
  const reduxDispatch = useDispatch();
  const [idleMillisecondsState, setIdleMillisecondsState] = useState<number>();
  const authorizationState = useSelector((state: RootState) => state.common.member.authorization);
  const idleModalVisibleState = useSelector((state: RootState) => state.UI.modals.idleModalVisible);

  // Idle Timer Config
  const idleTimer = useIdleTimer({
    timeout: idleMillisecondsState,
    startManually: true,
    onIdle: () => {
      // 設置閒置逾時狀態
      reduxDispatch(setIdleTimeoutStatusAction(true));
      // 開啟閒置跳窗
      reduxDispatch(setModalVisibleAction(ModalNamesEnum.IdleModal, true));
    }
  });

  /**
   * @description 取得閒置過久跳窗時間 (秒)
   */
  useEffect(() => {
    if (authorizationState) {
      (async () => {
        const response = await apiService.postInfoSysparams({ paramType: SystemParamTypesEnum.CalculateTime, paramId: SystemParamIdEnum.Idle });
        if (response && response.length > 0) {
          const idleMilliseconds = +response[0].paramValue * 1000;
          setIdleMillisecondsState(idleMilliseconds);
        }
      })();
    } else {
      setIdleMillisecondsState(undefined);
    }
  }, [authorizationState]);

  /**
   * @description 啟動 Idle Timer
   */
  useEffect(() => {
    // 說明：透過條件判斷，控制 Idle Timer 啟動或暫停。
    if (authorizationState && idleMillisecondsState && !idleModalVisibleState) {
      idleTimer.start();
    } else {
      idleTimer.pause();
    }
  }, [authorizationState, idleMillisecondsState, idleModalVisibleState, idleTimer]);

  return null;
};

export default IdleTimer;
